<template>
    <div class="modal fade" v-bind:id="modal_id" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1"
        aria-labelledby="staticBackdropLabel" aria-hidden="true">
        <div class="modal-dialog modal-xl">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="modal-select-product-title">
                        รายการสินค้า
                    </h5>
                    <div>
                        <button type="button" class="btn btn-sm btn-primary d-sm-none" v-on:click="confirm()"
                            data-bs-dismiss="modal">
                            ยืนยัน
                        </button>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                </div>
                <div class="modal-body">
                    <div class="row">
                        <div class="col-md-12">
                            <input type="text" placeholder="ค้นหา ชื่อสินค้า" class="form-control form-control-sm"
                                v-model="search" v-on:input="searchProduct()"
                                v-on:keyup.enter="selectBarcodeProduct()" />
                        </div>
                        <div class="col-12 my-2">
                            <div class="d-md-flex d-none" style="max-width: 1100px; overflow-x: scroll">
                                <div class="w-100" style="margin-right: 10px; white-space: nowrap"
                                    v-on:click="selectCategory(null)">
                                    <a :class="`text-center bg-white rounded btn btn-outline-secondary h3 text-body m-0 fs-6 fw-light ${selectedCategory == null ? 'border border-primary' : ''
                                        }`">
                                        {{ "สินค้าทั้งหมด" }}
                                    </a>
                                </div>
                                <template v-for="(item_c, i_c) in productCategories">
                                    <div :key="item_c.id + i_c" class="w-100"
                                        style="margin-right: 10px; white-space: nowrap"
                                        v-on:click="selectCategory(i_c)">
                                        <a :class="`text-center bg-white rounded btn btn-outline-secondary h3 text-body m-0 fs-6 fw-light ${selectedCategory == i_c ? 'border border-primary' : ''
                                            }`">
                                            {{ item_c.text }}
                                        </a>
                                    </div>
                                </template>
                            </div>
                        </div>
                        <div class="col-12 col-md-8">
                            <div class="row scroll-item">
                                <template v-for="(item, i) in modalProducts">
                                    <div :key="item.id + i" v-bind:class="`col-12 col-lg-4 px-2`" v-lazy-container="{ selector: 'img' }"
                                        v-on:click="selectProduct(i)" style="cursor: pointer">
                                        <div v-bind:class="`block mb-3 rounded px-3 py-2 rounded shadow-sm position-relative ${selectedProducts.includes(i)
                                            ? 'border border-primary'
                                            : ''
                                            }`" v-bind:id="`${item.id}-container`">
                                            <div class="posiotion-absolute" v-if="item.is_virtual">
                                                <span class="badge bg-danger text-white">V</span>
                                            </div>
                                            <div class="posiotion-absolute" v-if="item.is_bundle">
                                                <span class="badge bg-danger text-white">B</span>
                                            </div>
                                            <div class="pb-2 d-flex align-items-center justify-content-center">
                                                <img class="rounded" width="120px" v-bind:data-src="item.product_image"
                                                    alt="" />
                                            </div>
                                            <p class="text-start mb-1 text-body product-name fw-400">
                                                {{ item.name }}
                                            </p>
                                            <div class="d-flex flex-wrap align-items-baseline gap-1"
                                                style="height: 57px;overflow-y: auto;">
                                                <span :class="`badge rounded-pill  ${item.chosen_package_id == null
                                                    ? 'text-white bg-primary'
                                                    : 'border border-danger text-danger'
                                                    }`" v-on:click.stop="selectPackage(i, null)">
                                                    {{ item.unit_name }}
                                                </span>
                                                <span v-for="(item_p, i_p) in item.product_packages"
                                                    :key="item_p.id + '-' + i_p"
                                                    :class="`badge rounded-pill  ${item.chosen_package_id == item_p.id
                                                        ? 'text-white bg-primary'
                                                        : 'border border-danger text-danger'
                                                        }`" v-on:click.stop="selectPackage(i, i_p)">
                                                    {{ item_p.name }} ({{ item_p.amount_per_unit }})
                                                </span>
                                            </div>
                                            <p v-show="item.stock_remaining != null ||
                                                item.stock_remaining != undefined
                                                " class="mb-0">
                                                กำลังทำรายการ:
                                                <span class="text-danger">{{
                                                    item.product_ordered_amount
                                                    }}</span>
                                                {{ item.unit_name }}
                                            </p>
                                            <p v-show="item.stock_remaining != null ||
                                                item.stock_remaining != undefined
                                                " class="mb-0">
                                                คงคลัง: {{ item.stock_remaining }} สุทธิ:
                                                <span class="text-success">{{
                                                    item.stock_remaining - item.product_ordered_amount
                                                    }}</span>
                                                {{ item.unit_name }}
                                            </p>
                                            <template v-if="selectedProducts.includes(i)">
                                                <div class="d-flex justify-content-between align-items-center gap-3">
                                                    <label for="">จำนวน</label>
                                                    <input v-on:click.stop type="number"
                                                        class="form-control form-control-sm" v-model="item.amount"
                                                        :ref="`input_amo_${i}`" v-on:input="updateAmount(i)" min="1" />
                                                </div>
                                            </template>
                                        </div>
                                    </div>
                                    <div :key="'scroll-' + item.id + i" class="col-12" v-if="i + 1 == pageOffset"
                                        id="scrolltrigger" style="margin-top: 10px; height: 50px"></div>
                                </template>
                            </div>
                        </div>
                        <div class="col-12 col-md-4">
                            <div class="row my-2 d-flex d-sm-none">
                                <div class="col-12 mt-2">
                                    สรุปรายการ
                                </div>
                            </div>
                            <div class="row scroll-detail">
                                <template v-for="item in selectedProducts">
                                    <div :key="`selected` + item" class="col-12">
                                        <div class="d-flex justify-content-between">
                                            <span>{{ modalProducts[item].name }}</span>
                                            <div class="d-flex justify-content-between gap-1">
                                                <span>{{ modalProducts[item].amount }}</span>
                                                <span>{{ modalProducts[item].chosen_unit_name }}</span>
                                            </div>
                                        </div>
                                        <p v-show="item.stock_remaining != null ||
                                            item.stock_remaining != undefined
                                            " class="mb-0">
                                            <span>กำลังทำรายการ:
                                                <span class="text-danger">{{
                                                    modalProducts[item].product_ordered_amount
                                                    }}</span></span>
                                            <span>คงคลัง: {{ modalProducts[item].stock_remaining }}</span>
                                            <span>สุทธิ:
                                                <span class="text-success">{{
                                                    modalProducts[item].stock_remaining -
                                                    modalProducts[item].product_ordered_amount
                                                    }}</span></span>
                                            {{ modalProducts[item].unit_name }}
                                        </p>
                                        <hr class="my-1" />
                                    </div>
                                </template>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-primary" v-on:click="confirm()" data-bs-dismiss="modal">
                        ยืนยัน
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: "modal-select-product",
    props: ["modal_id", "api_products", "api_product_category", "use_cost_price", "price_type_id"],
    data() {
        return {
            productCategories: [],
            modalProducts: [],
            selectedProducts: [],
            search: "",
            currentPage: 1,
            maxPerPage: 12,
            nextPageUrl: "",
            lastPage: 0,
            timeObserve: 0,
            customer_id: null,
            debounce: null,
            selectedCategory: null,
            isSearching: false,
            pendingAmount: 0, // เก็บจำนวนที่พิมพ์ +10 +20
        };
    },
    async mounted() {
        let API_PRODUCTS = axios.get(this.api_products);
        let API_PRODUCT_CATEGORIES = axios.get(this.api_product_category);
        let res = await Promise.all([API_PRODUCTS, API_PRODUCT_CATEGORIES]);
        this.modalProducts = res[0].data.products.data;
        this.productCategories = res[1].data.result;
        this.nextPageUrl = res[0].data.products.next_page_url;
    },
    updated() {
        this.scrollTrigger();
    },
    computed: {
        pageOffset() {
            return this.maxPerPage * this.currentPage;
        },
    },
    methods: {
        async selectBarcodeProduct() {
            if (this.modalProducts.length > 0) {
                // ตรวจสอบว่ามีการพิมพ์ +ตัวเลข เช่น +10, +20
                const plusMatch = this.search.match(/^\+(\d+)$/);
                if (plusMatch) {
                    // เก็บจำนวนที่ต้องการเพิ่มไว้ใน state
                    this.pendingAmount = parseInt(plusMatch[1]);
                    this.search = "";
                    return;
                }

                if (/^\d+$/.test(this.search)) {
                    clearTimeout(this.debounce);
                    let res = await axios.get('/util/get-product-by-barcode', {
                        params: {
                            barcode: this.search,
                        },
                    });
                    if (res.data.success) {
                        let found = this.modalProducts.findIndex((item) => {
                            return (item.id == res.data.product.id) && (item.chosen_package_id == res.data.product.product_package_id);
                        });
                        if (found >= 0) {
                            let foundSelected = this.selectedProducts.findIndex((item) => item == found);
                            if (foundSelected === -1) {
                                this.selectedProducts.push(found);
                            }
                            if (!this.modalProducts[found].amount) {
                                // ใช้จำนวนจาก pendingAmount ถ้ามี ถ้าไม่มีใช้ 1
                                this.modalProducts[found].amount = this.pendingAmount > 0 ? this.pendingAmount : 1;
                            } else {
                                // บวกจำนวนเดิมกับ pendingAmount ถ้ามี ถ้าไม่มีบวก 1
                                this.modalProducts[found].amount = Number(this.modalProducts[found].amount) + (this.pendingAmount > 0 ? this.pendingAmount : 1);
                            }
                            // รีเซ็ต pendingAmount หลังใช้งานเสร็จ
                            this.pendingAmount = 0;
                        } else {
                            // เก็บเฉพาะรายการที่ถูกเลือกไว้
                            let selectedItems = [];
                            this.selectedProducts.forEach(index => {
                                selectedItems.push(this.modalProducts[index]);
                            });

                            // เคลียร์รายการทั้งหมดแล้วใส่รายการที่เลือกกลับ
                            this.modalProducts = selectedItems;

                            // อัปเดต selectedProducts index ใหม่
                            this.selectedProducts = [];
                            for (let i = 0; i < selectedItems.length; i++) {
                                this.selectedProducts.push(i);
                            }

                            // เพิ่มสินค้าใหม่จากบาร์โค้ด
                            let newProduct = res.data.product;
                            // ใช้จำนวนจาก pendingAmount ถ้ามี ถ้าไม่มีใช้ 1
                            newProduct.amount = this.pendingAmount > 0 ? this.pendingAmount : 1;
                            newProduct.chosen_unit_name = newProduct.unit_name;
                            newProduct.chosen_package_id = null;
                            newProduct.amount_per_unit = null;
                            newProduct.stock_remaining = res.data.product.stock_remaining;
                            newProduct.product_ordered_amount = res.data.product.product_ordered_amount;
                            newProduct.product_image = res.data.product.product_image;
                            newProduct.product_packages = res.data.product.product_packages;
                            newProduct.chosen_package_id = res.data.product.product_package_id;
                            if (newProduct.chosen_package_id) {
                                newProduct.chosen_unit_name = res.data.product.product_package_name;
                            }
                            this.modalProducts.push(newProduct);
                            this.selectedProducts.push(this.modalProducts.length - 1);
                            // รีเซ็ต pendingAmount หลังใช้งานเสร็จ
                            this.pendingAmount = 0;
                        }
                    }
                    this.search = "";
                }
            }
        },
        async selectCategory(index) {
            this.selectedCategory = index;
            this.searchProduct();
        },
        searchProduct() {
            this.isSearching = true;
            clearTimeout(this.debounce);
            this.debounce = setTimeout(async () => {
                try {
                    let res = await axios.get(this.api_products, {
                        params: {
                            search: this.search,
                            category_id:
                                this.selectedCategory != null
                                    ? this.productCategories[this.selectedCategory].id
                                    : null,
                        },
                    });
                    let count = this.selectedProducts.length;
                    let products = [];
                    let newData = res.data.products.data;
                    for (let i = 0; i < count; i++) {
                        products.push(this.modalProducts[this.selectedProducts[i]]);
                        this.selectedProducts[i] = i;
                    }
                    products = products.concat(newData);
                    // add unique
                    products = products.filter(
                        (value, index, self) =>
                            index === self.findIndex((t) =>
                                t.id === value.id &&
                                (t.chosen_package_id ? t.chosen_package_id : null) === (value.chosen_package_id ? value.chosen_package_id : null)
                            )
                    );
                    this.modalProducts = products;
                    this.nextPageUrl = res.data.products.next_page_url;
                    this.currentPage = 1;
                } catch (error) {
                    console.error('Error searching products:', error);
                } finally {
                    this.isSearching = false;
                }
            }, 300);
        },
        updateAmount(index) {
            this.$forceUpdate();
        },
        async selectProduct(index) {
            let found = this.selectedProducts.findIndex((item) => item == index);
            if (found >= 0) {
                this.selectedProducts.splice(found, 1);
            } else {
                this.selectedProducts.push(index);
                this.modalProducts[index].amount = 1;
                this.modalProducts[index].chosen_unit_name =
                    this.modalProducts[index].unit_name;
                this.modalProducts[index].chosen_package_id = null;
                this.modalProducts[index].amount_per_unit = null;
                setTimeout(() => {
                    this.$refs[`input_amo_${index}`][0].focus()
                }, 100)
            }
        },
        scrollTrigger() {
            const observer = new IntersectionObserver(async (entries) => {
                if (entries[0].isIntersecting && entries[0].time != this.timeObserve) {
                    console.log("trigger");
                    this.timeObserve = entries[0].time;
                    let res = await axios.get(this.nextPageUrl);
                    let newProducts = [...this.modalProducts, ...res.data.products.data];
                    if (this.currentPage < res.data.products.current_page) {
                        this.currentPage = res.data.products.current_page;
                        this.nextPageUrl = res.data.products.next_page_url;
                        this.lastPage = res.data.products.last_page;
                        this.modalProducts = newProducts;
                    }
                }
            });

            if (document.getElementById("scrolltrigger")) {
                observer.observe(document.getElementById("scrolltrigger"));
            }
        },
        selectPackage(index, index_package) {
            let found = this.selectedProducts.findIndex((item) => item == index);
            let p_index = index;
            if (found >= 0) {
                p_index = found;
            } else {
                this.selectedProducts.push(index);
            }
            this.modalProducts[p_index].amount = 1;
            this.modalProducts[p_index].chosen_unit_name =
                this.modalProducts[p_index].unit_name;
            this.modalProducts[p_index].chosen_package_id = null;
            this.modalProducts[p_index].amount_per_unit = null;
            let packages = this.modalProducts[index].product_packages;
            if (index_package == null) {
                this.modalProducts[index].chosen_unit_name =
                    this.modalProducts[index].unit_name;
                this.modalProducts[index].chosen_package_id = null;
                this.modalProducts[index].amount_per_unit = null;
            } else {
                this.modalProducts[
                    index
                ].chosen_unit_name = `${packages[index_package].name} (${packages[index_package].amount_per_unit})`;
                this.modalProducts[index].chosen_package_id =
                    packages[index_package].id;
                this.modalProducts[index].amount_per_unit =
                    packages[index_package].amount_per_unit;
            }
            setTimeout(() => {
                this.$refs[`input_amo_${index}`][0].focus()
            }, 100)
            this.$forceUpdate();
        },
        async confirm() {
            let products = [];
            this.selectedProducts.forEach((item) => {
                let itemP = this.modalProducts[item];
                let product = {};
                product.product_name = itemP.name;
                product.amount = Number(itemP.amount);
                product.amount_per_unit = Number(itemP.amount_per_unit) ? Number(itemP.amount_per_unit) : 1;
                product.discount = 0.0;
                product.expiry_date = null;
                product.manufacturing_no = null;
                product.price = null;
                product.product_id = itemP.id;
                product.product_package_id = itemP.chosen_package_id;
                product.product_package_name = itemP.chosen_unit_name;
                product.shelf_level_id = null;
                product.subtotal = 0.0;
                product.total = 0.0;
                product.total_text = "0.00";
                product.unit_name = itemP.unit_name;
                product.price = itemP.price;
                product.vat = 0.0;
                product.is_virtual = itemP.is_virtual ? true : false;
                product.product_ordered_amount = itemP.product_ordered_amount;
                product.stock_remaining = itemP.stock_remaining;
                product.is_bundle = itemP.is_bundle ? true : false;
                product.product_image = itemP.product_image;
                product.has_image = itemP.has_image ? true : false;
                product.is_promotion_price = itemP.is_promotion_price;
                products.push(product);
            });
            let res = await axios.post("/util/modal-select/get-products-price", {
                products,
                customer_id: this.customer_id,
                use_cost_price: this.use_cost_price,
                price_type_id: this.price_type_id
            });
            products = res.data.items;

            this.$emit("confirm", products);
            this.selectedProducts = [];
        },
    },
};
</script>
<style scoped>
.scroll-detail {
    max-height: 60vh;
    overflow-y: scroll;
}

.scroll-item {
    max-height: 60vh;
    overflow-y: scroll;
}

@media screen and (max-width: 767px) {
    .scroll-detail {
        max-height: 125px;
        overflow-y: scroll;
    }

    .scroll-item {
        max-height: 400px;
        overflow-y: scroll;
    }
}

@media screen and (max-width: 821px) {
    .modal-dialog {
        max-width: 100% !important;
    }
}
</style>
